// src/components/KMUI/KSelect.tsx

import { FormControl, InputAdornment, TextField } from '@mui/material'
import { ComponentProps, ReactNode } from 'react'

type Props = {
  children: ReactNode
  icon?: ReactNode
} & ComponentProps<typeof TextField>

export const KSelect = ({ children, icon, ...rest }: Props) => (
  <FormControl fullWidth>
    <TextField
      InputProps={{
        startAdornment: icon && (
          <InputAdornment position={'start'}>{icon}</InputAdornment>
        ),
      }}
      select
      {...rest}
    >
      {children}
    </TextField>
  </FormControl>
)
